export const MARKER_MANUAL = 'MARKER_MANUAL';
export const MARKER_MILE = 'MARKER_MILE';
export const MARKER_KILOMETER = 'MARKER_KILOMETER';
export const MARKER_HALF_MARATHON = 'MARKER_HALF_MARATHON';
export const MARKER_5K = 'MARKER_5K';

export const LAP_BY_COURSE_POINTS_SPLIT_TYPES = [MARKER_MANUAL, MARKER_MILE, MARKER_KILOMETER, MARKER_HALF_MARATHON];
